import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  buttonContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
  },
  buttonContainerInner: { flexDirection: 'row', gap: 16 },
  infoContainer: { gap: 8 },
  infoContainerInner: { flexDirection: 'row', alignItems: 'center' },
  icon: {
    fontSize: 24,
    marginRight: 4,
  },
});
